import React from 'react';
import Icon from '../../../components/AppIcon';

const SectionNav = ({ sections, activeSection, onSelect }) => {
  return (
    <nav className="space-y-1">
      {sections?.map((section) => (
        <button
          key={section?.id}
          onClick={() => onSelect(section?.id)}
          className={`
            w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium text-left
            transition-smooth
            ${activeSection === section?.id
              ? 'bg-primary/10 text-primary' :'text-muted-foreground hover:text-foreground hover:bg-muted'}
          `}
        >
          <Icon
            name={section?.icon}
            size={16}
            color={activeSection === section?.id ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
          />
          <span>{section?.label}</span>
          {section?.badge && (
            <span className="ml-auto text-xs bg-primary/15 text-primary px-1.5 py-0.5 rounded font-mono">
              {section?.badge}
            </span>
          )}
        </button>
      ))}
    </nav>
  );
};

export default SectionNav;
